(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var items = document.querySelectorAll('.featured-content-section .grid__item');

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  items.forEach(function(item) {
    observer.observe(item);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var items = document.querySelectorAll('.guarantee-section .grid__item');

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  items.forEach(function(item) {
    observer.observe(item);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header-container');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.querySelector('.quotes-mobile-only');
  if (!wrapper) return;

  var slides = wrapper.querySelectorAll('.quotes-mobile__slide');
  var prevBtn = wrapper.querySelector('.quotes-mobile__prev');
  var nextBtn = wrapper.querySelector('.quotes-mobile__next');
  var counter = wrapper.querySelector('.quotes-mobile__current');
  var currentIndex = 0;

  function showSlide(index) {
    slides[currentIndex].classList.remove('is-active');
    currentIndex = index;

    if (currentIndex < 0) {
      currentIndex = slides.length - 1;
    }
    if (currentIndex >= slides.length) {
      currentIndex = 0;
    }

    slides[currentIndex].classList.add('is-active');

    if (counter) {
      counter.textContent = currentIndex + 1;
    }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      showSlide(currentIndex + 1);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      showSlide(currentIndex - 1);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
